import styled from 'styled-components';
import {interceptProps} from '@/styled-components/utils';
import {FULL_SCREEN, LAYOUT_SIZE, LAYOUT_Z_INDEX, palette} from '@/styles';
import FoldHandleIcon from './fold.svg';
import UnfoldHandleIcon from './unfold.svg';

export const SidePanelBase = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

export const SidePanelWrapper = styled.div`
  position: absolute;
  display: flex;
  left: ${LAYOUT_SIZE.SIDE_BAR}px;
  width: ${LAYOUT_SIZE.SIDE_PANEL}px;
  height: ${FULL_SCREEN.vh};
  background-color: ${palette.white};
  z-index: ${LAYOUT_Z_INDEX.SIDE_PANEL};
  border-right: solid 1px ${palette.gray300};
  transition: left 100ms ease-in-out;
`;

export const SidePanelScrollBody = styled.div`
  flex-grow: 1;
  overflow: auto;
`;

export const SidePanelFooter = styled.div`
  position: relative;
  padding: 8px 16px;
  border-top: solid 1px ${palette.gray200};
`;

export const Handle = styled.div.withConfig({
  shouldForwardProp: interceptProps(['open']),
})<{
  open?: boolean;
}>`
  position: absolute;
  top: 16px;
  width: 24px;
  height: 42px;
  border: solid 1px ${palette.gray300};
  border-left: none;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  background-color: ${palette.white};
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
  right: -25px;
  ${({open}) =>
    `
      background-image: url(${open ? FoldHandleIcon : UnfoldHandleIcon});
  `}
`;

export * from './SidePanelHead';
export * from './Tabs';
